module.exports = __webpack_public_path__ + "assets/img/andrew_smith_photo.75e9b00a.svg";